module.exports = __webpack_public_path__ + "img/img-4.bf9f452d.png";